module.exports = __webpack_public_path__ + "img/SKMJ_standard3.f92f3134.jpg";